<template>
  <div class="nebInput"
    :style="{ width }"
    :class="{ hasIcon: icon !== '' }"
  >
    <input type="text"
      :placeholder="placeholder"
      :class="{
        hasError,
        disabled,
        readOnly
      }"
      :value="value"
      @input="onInput"
      @focus="e => $emit('focus', e)"
      @blur="e => $emit('blur', e)"
      @keyup.enter="onSubmit"
    />

    <div class="nebInput-icon"
      v-if="icon"
    >
      <neb-icon :name="icon"
        height="10px"
        width="10px"
      />
    </div>

    <div class="nebInput-clear"
      v-show="clearable && value"
      :class="{ hasButton: button !== null }"
    >
      <neb-icon name="x"
        height="12px"
        width="12px"
        @click.native="onClear"
      ></neb-icon>
    </div>

    <button v-if="button"
      @click.prevent="onSubmit"
    >
      <neb-icon name="search" />
    </button>
  </div>
</template>

<script>
import NebIcon from '../../Icon'

export default {
  name: 'NebInput',

  components: {
    NebIcon
  },

  props: {
    value: {
      type: [ String, Number ],
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Enter Value'
    },
    hasError: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '100%'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    clearable: {
      type: Boolean,
      default: false
    },
    button: {
      type: String,
      default: null
    }
  },

  methods: {
    onInput (e) { this.$emit('input', e.target.value) },
    onClear (e) {
      e.stopPropagation()
      e.preventDefault()

      this.$emit('clear')
    },
    onSubmit (e) { this.$emit('action:submit', e) }
  }
}
</script>

<style lang="scss" scoped>
@import '../../style.scss';

.nebInput {
  height: 34px;
  position: relative;
  display: flex;

  &-icon {
    position: absolute;
    top: 0;
    left: 15px;
    display: flex;
    align-items: center;
    height: 100%;

    .nebIcon {
      color: $slate-grey;
    }
  }

  &-clear {
    position: absolute;
    top: 0;
    right: 15px;
    display: flex;
    align-items: center;
    height: 100%;

    &.hasButton {
      right: 45px;
    }

    .nebIcon {
      color: $slate-grey;
      cursor: pointer;
    }
  }

  button {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    padding: 0 1em;
    border-radius: 0 3px 3px 0;
    box-sizing: border-box;
    background-color: $tiffany-blue;
    color: $white;
    // border: solid 1px $light-grey-blue;
  }

  &.hasIcon {
    input {
      padding-left: 35px;
    }
  }

  input {
    width: 100%;
    box-sizing: border-box;
    height: 34px;
    border-radius: 3px;
    border: solid 1px $light-grey-blue;
    background-color: $white;
    padding: 10px 15px;
    font-size: 12px;
    background-color: $white;
    color: $slate-grey;

    &::placeholder {
      color: $warm-grey;
    }

    &:active,
    &:focus {
      box-shadow: 0 0 3px 0 $tiffany-blue;
      border: solid 1px $tiffany-blue;
    }

    &.disabled {
      border-color: $pinkish-grey;
      background-color: $white-four;
      color: $pinkish-grey;
    }

    &.readOnly {
      border-top: none;
      border-left: none;
      border-right: none;
      border-bottom: 2px solid $warm-grey;
      border-radius: 0;
    }

    &.hasError {
      border: solid 1px $blush;

      &:active,
      &:focus {
        box-shadow: 0 0 3px 0 $blush;
      }
    }
  }
}
</style>
